import { AwcGame } from 'models/casino';

export const sortGame = (games: AwcGame[]) => {
  return games.map((game) => {
    const name = game.name.toLowerCase();

    // game code
    if (game.gameCode === 'PP-SLOT-411') {
      return { ...game, order: 1 };
    } else if (game.gameCode === 'PP-SLOT-443') {
      return { ...game, order: 2 };
    } else if (game.gameCode === 'PP-SLOT-546') {
      return { ...game, order: 3 };
    } else if (game.gameCode === 'PP-SLOT-002') {
      return { ...game, order: 4 };
    } else if (game.gameCode === 'PP-SLOT-364') {
      return { ...game, order: 5 };
    } else if (game.gameCode === 'PP-SLOT-464') {
      return { ...game, order: 6 };
    } else if (game.gameCode === 'PP-SLOT-183') {
      return { ...game, order: 7 };
    } else if (game.gameCode === 'PP-SLOT-524') {
      return { ...game, order: 8 };
    } else if (game.gameCode === 'PP-SLOT-082') {
      return { ...game, order: 9 };
    } else if (game.gameCode === 'PP-SLOT-547') {
      return { ...game, order: 10 };
    } else if (game.gameCode === 'PP-SLOT-189') {
      return { ...game, order: 11 };
    } else if (game.gameCode === 'PP-SLOT-362') {
      return { ...game, order: 12 };
    } else if (game.gameCode === 'PP-SLOT-306') {
      return { ...game, order: 13 };
    } else if (game.gameCode === 'PP-SLOT-245') {
      return { ...game, order: 14 };
    } else if (game.gameCode === 'PP-SLOT-505') {
      return { ...game, order: 15 };
    } else if (game.gameCode === 'PP-SLOT-346') {
      return { ...game, order: 16 };
    } else if (game.gameCode === 'PP-SLOT-439') {
      return { ...game, order: 17 };
    } else if (game.gameCode === 'PP-SLOT-116') {
      return { ...game, order: 18 };
    } else if (game.gameCode === 'PP-SLOT-036') {
      return { ...game, order: 19 };
    } else if (game.gameCode === 'PP-SLOT-552') {
      return { ...game, order: 20 };
    }
    if (game.platform.gameType === 'LIVE') {
      if (name.includes('casino')) {
        return { ...game, order: 1 };
      } else if (name.includes('speed baccarat')) {
        return { ...game, order: 3 };
      } else if (name.includes('baccarat')) {
        return { ...game, order: 2 };
      } else if (name.includes('roulette')) {
        return { ...game, order: 5 };
      } else if (name.includes('dragon tiger')) {
        return { ...game, order: 7 };
      } else if (name.includes('sic bo')) {
        return { ...game, order: 6 };
      } else if (name.includes('blackjack')) {
        return { ...game, order: 8 };
      }
      return { ...game, order: 4 };
    }
    return { ...game, order: game.diplayOrder };
  });
};
